import React, { Fragment, useEffect, useState } from "react";
import styles from "./Dashboard.module.css";
import DashNavbar from "../Helper/DashNavbar/DashNavbar";
import { useNavigate } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";

const Dashboard = () => {

  const navigate = useNavigate();

  const goToEvents = () => {
    navigate("/admin/allEvents");
  }
  
  return (
    <Fragment>
      <main className={styles.mainContainer}>
        <section className={styles.dashboard}>
          <div className={styles.nav}>
            <DashNavbar />
          </div>

          <div className={styles.pageContainer}>
            <h4 className={styles.headline}>Dashboard</h4>
          </div>
        </section>
      </main>
    </Fragment>
  );
};
export default Dashboard;
